// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CompetitionsPage.css */

.competition-card {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  margin: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
}

.names-list {
  list-style: none;
  padding: 0;
}
.active-card {
  background-color: yellow;
}
.name-card {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  margin: 10px 0;
}

.green-card {
  background-color: #4caf50; /* Green color for cards with Tag ID */
  color: #fff; /* White text on green background */
}
.name-card:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.green-card:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.competition-card h3 {
  font-size: 20px;
  margin: 0;
}

.competition-card p {
  margin: 8px 0;
}

.competition-card:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
/* Reset some default styles for consistency across browsers */
body,
h1,
h2,
h3,
p,
ul,
li {
  margin: 0;
  padding: 0;
}

/* Apply a background color and set font styles */
body {
  font-family: "Roboto", sans-serif;
  background-color: #f5f5f5;
  color: #333;
  line-height: 1.6;
}

/* Create a header with a background color and center-aligned text */
header {
  background-color: #2196f3;
  color: #fff;
  text-align: center;
  padding: 20px;
}

/* Style the navigation menu */
nav {
  text-align: center;
}

nav ul {
  list-style: none;
}

nav li {
  display: inline;
  margin-right: 15px;
}

nav a {
  text-decoration: none;
  color: #2196f3;
  font-weight: bold;
}

/* Add a container to center the content on the page */
.container {
  max-width: 960px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Style headings and paragraphs */
h1,
h2,
h3 {
  color: #333;
  margin: 10px 0;
}

/* Style links */
a {
  color: #2196f3;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

/* Add some padding to paragraphs and lists */
p,
ul {
  margin-bottom: 15px;
}

/* Style buttons */
.button {
  display: inline-block;
  padding: 10px 20px;
  background-color: #2196f3;
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  transition: background-color 0.3s ease-in-out;
}

.button:hover {
  background-color: #1976d2;
}

/* Add a footer with a background color and center-aligned text */
footer {
  background-color: #2196f3;
  color: #fff;
  text-align: center;
  padding: 10px;
}

/* Responsive design: Adjust layout for smaller screens */
@media (max-width: 768px) {
  header {
    padding: 10px;
  }

  nav {
    font-size: 14px;
  }

  .container {
    padding: 10px;
  }

  footer {
    padding: 5px;
  }
}
.modal {
  display: none; /* Hide the modal by default */
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 50%;
  box-shadow: 0px 0px 10px 0px #888;
  position: relative;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/CompetitionsPage.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,wCAAwC;EACxC,sBAAsB;EACtB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;EACjE,WAAW,EAAE,mCAAmC;AAClD;AACA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;AACA,8DAA8D;AAC9D;;;;;;;EAOE,SAAS;EACT,UAAU;AACZ;;AAEA,iDAAiD;AACjD;EACE,iCAAiC;EACjC,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA,sDAAsD;AACtD;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,kCAAkC;AAClC;;;EAGE,WAAW;EACX,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,6CAA6C;AAC7C;;EAEE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iEAAiE;AACjE;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,yDAAyD;AACzD;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;AACA;EACE,aAAa,EAAE,8BAA8B;EAC7C,eAAe;EACf,UAAU;EACV,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":["/* CompetitionsPage.css */\n\n.competition-card {\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 16px;\n  margin: 16px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n  transition: transform 0.2s, box-shadow 0.2s;\n  cursor: pointer;\n}\n\n.names-list {\n  list-style: none;\n  padding: 0;\n}\n.active-card {\n  background-color: yellow;\n}\n.name-card {\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  padding: 10px;\n  margin: 10px 0;\n}\n\n.green-card {\n  background-color: #4caf50; /* Green color for cards with Tag ID */\n  color: #fff; /* White text on green background */\n}\n.name-card:hover {\n  transform: scale(1.02);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.green-card:hover {\n  transform: scale(1.02);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.competition-card h3 {\n  font-size: 20px;\n  margin: 0;\n}\n\n.competition-card p {\n  margin: 8px 0;\n}\n\n.competition-card:hover {\n  transform: scale(1.02);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n/* Reset some default styles for consistency across browsers */\nbody,\nh1,\nh2,\nh3,\np,\nul,\nli {\n  margin: 0;\n  padding: 0;\n}\n\n/* Apply a background color and set font styles */\nbody {\n  font-family: \"Roboto\", sans-serif;\n  background-color: #f5f5f5;\n  color: #333;\n  line-height: 1.6;\n}\n\n/* Create a header with a background color and center-aligned text */\nheader {\n  background-color: #2196f3;\n  color: #fff;\n  text-align: center;\n  padding: 20px;\n}\n\n/* Style the navigation menu */\nnav {\n  text-align: center;\n}\n\nnav ul {\n  list-style: none;\n}\n\nnav li {\n  display: inline;\n  margin-right: 15px;\n}\n\nnav a {\n  text-decoration: none;\n  color: #2196f3;\n  font-weight: bold;\n}\n\n/* Add a container to center the content on the page */\n.container {\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Style headings and paragraphs */\nh1,\nh2,\nh3 {\n  color: #333;\n  margin: 10px 0;\n}\n\n/* Style links */\na {\n  color: #2196f3;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n/* Add some padding to paragraphs and lists */\np,\nul {\n  margin-bottom: 15px;\n}\n\n/* Style buttons */\n.button {\n  display: inline-block;\n  padding: 10px 20px;\n  background-color: #2196f3;\n  color: #fff;\n  text-decoration: none;\n  border-radius: 4px;\n  transition: background-color 0.3s ease-in-out;\n}\n\n.button:hover {\n  background-color: #1976d2;\n}\n\n/* Add a footer with a background color and center-aligned text */\nfooter {\n  background-color: #2196f3;\n  color: #fff;\n  text-align: center;\n  padding: 10px;\n}\n\n/* Responsive design: Adjust layout for smaller screens */\n@media (max-width: 768px) {\n  header {\n    padding: 10px;\n  }\n\n  nav {\n    font-size: 14px;\n  }\n\n  .container {\n    padding: 10px;\n  }\n\n  footer {\n    padding: 5px;\n  }\n}\n.modal {\n  display: none; /* Hide the modal by default */\n  position: fixed;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.4);\n}\n\n.modal-content {\n  background-color: #fefefe;\n  margin: 15% auto;\n  padding: 20px;\n  border: 1px solid #888;\n  width: 50%;\n  box-shadow: 0px 0px 10px 0px #888;\n  position: relative;\n}\n\n.close {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.close:hover {\n  color: black;\n  text-decoration: none;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
